import { HttpInterceptorFn } from '@angular/common/http';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
    const modifiedReq = req.clone({
        headers: req.headers.set('Referrer-Policy', 'origin-when-cross-origin'),
    });
    return next(modifiedReq);
};
